<template>
  <div class="buy-page">
    <section class="product-detail">
      <div class="product-media">
        <div
          class="product-carousel"
          @mouseenter="stopProductCarousel"
          @mouseleave="startProductCarousel"
          @focusin="stopProductCarousel"
          @focusout="startProductCarousel"
        >
          <div class="main-product-image">
            <div
              class="carousel-track"
              :style="{ transform: `translateX(-${currentImageIndex * 100}%)` }"
            >
              <div
                v-for="image in productImages"
                :key="image.src"
                class="carousel-slide"
              >
                <img :src="image.src" :alt="image.alt">
              </div>
            </div>
          </div>
          <div class="carousel-dots" aria-label="Product image carousel pagination">
            <button
              v-for="(image, index) in productImages"
              :key="`dot-${image.src}`"
              type="button"
              class="carousel-dot"
              :class="{ active: currentImageIndex === index }"
              :aria-label="`Show product image ${index + 1}`"
              @click="goToProductImage(index)"
            ></button>
          </div>
        </div>
        <div class="thumb-list" aria-label="产品图片缩略图">
          <button
            v-for="(image, index) in productImages"
            :key="image.src"
            type="button"
            class="thumb"
            :class="{ active: currentImageIndex === index }"
            @click="goToProductImage(index)"
          >
            <img :src="image.src" :alt="image.alt">
          </button>
        </div>
      </div>
      <div class="product-info">
        <h1>闪耀星启 孤独症儿童学习机</h1>

        <div class="price-row">
          <span class="currency">¥</span>
          <span class="price">{{ totalPriceText }}</span>
        </div>

        <p class="description">
          游戏训练为平板电脑的主要训练入口。经过游戏过程，潜移默化，循序渐进的
          对小朋友的社交、认知、协调、耐心、情绪控制产生影响和提升。
        </p>

        <div class="action-row">
          <div class="quantity-control" aria-label="购买数量">
            <button type="button" aria-label="减少数量" @click="decrease">−</button>
            <span>{{ quantity }}</span>
            <button type="button" aria-label="增加数量" @click="increase">+</button>
          </div>
          <button type="button" class="buy-button" @click="showOrderDialog = true">立即购买</button>
        </div>

        <div class="service-row">
          <span>急速发货</span>
          <span>配送到家</span>
          <span>客服连线</span>
        </div>

      </div>
    </section>

    <transition name="modal-fade">
      <div v-if="showOrderDialog" class="modal-overlay" @click.self="handleDialogOverlayClick">
        <div
          class="order-dialog"
          :class="{ 'qr-dialog': paymentQrCode }"
          role="dialog"
          aria-modal="true"
          :aria-label="paymentQrCode ? '微信支付二维码' : '购买确认'"
        >
          <div v-if="paymentQrCode" class="payment-qr-only">
            <img :src="paymentQrCode" alt="微信支付二维码">
            <p>请使用微信扫码支付，支付结果确认后将自动提示</p>
            <button type="button" class="payment-cancel-button" @click="cancelPayment">取消支付</button>
          </div>

          <template v-else>
          <button type="button" class="dialog-close" aria-label="关闭弹窗" @click="closeOrderDialog">×</button>
          <div class="dialog-header">
            <div>
              <h2>提交订单</h2>
              <p>请确认并填写以下信息，完成订单提交</p>
            </div>
          </div>

          <div class="order-form">
            <label class="order-row">
              <span class="order-icon user-icon" aria-hidden="true">
                <svg viewBox="0 0 1024 1024" focusable="false">
                  <path d="M610.919609 1004.488841h-196.678132c-186.563169 0-333.904363 0-333.904363-96.771497v-19.346314c0-181.348521 149.807734-328.865823 333.904363-328.865823h196.678132c184.096629 0 333.905387 147.516278 333.905387 328.865823v19.346314c-0.035836 96.771498-154.776649 96.771498-333.905387 96.771497z m-196.712944-386.977458c-152.099189 0-275.864399 121.473755-275.864399 270.823811v19.348361c0 38.728462 159.42816 38.728462 275.864399 38.728463H610.883773c96.383445 0 275.864399 0 275.864399-38.728463v-19.348361c0-149.350057-123.76521-270.823812-275.864399-270.823811H414.206665z m88.524101-77.423137c-146.17806 0-265.045003-117.175484-265.045003-261.203385S356.552706 17.715264 502.730766 17.715264s265.045003 117.140672 265.045003 261.168573S648.874014 540.088246 502.730766 540.088246z m-207.002992-261.203385c0 111.994625 92.859232 203.162398 207.002992 203.162398s207.002992-91.132961 207.002992-203.162398c0-112.030461-92.859232-203.127586-207.002992-203.127586s-207.002992 91.131937-207.002992 203.127586z" fill="#0a8929"></path>
                </svg>
              </span>
              <span class="order-label">下单人<i>*</i></span>
              <input v-model.trim="orderForm.customerName" class="order-control" type="text" placeholder="请输入下单人姓名"/>
            </label>

            <label class="order-row">
              <span class="order-icon phone-icon" aria-hidden="true">
                <svg viewBox="0 0 1024 1024" focusable="false">
                  <path d="M716.2 928.2h-7.7C351.2 923.9 63.9 625.4 68.3 262.7c0.1-5.2 0.3-12.1 0.8-19.5 2.5-45.2 31.8-83.6 74.7-97.8l125-41.5c27.7-9.2 57.3-7 83.4 6 26.1 13.1 45.5 35.6 54.7 63.3L442.5 281c18.9 57.1-12.1 119-69.2 138-6 2-10.8 6.4-13.3 12.3-1.5 3.7-2.8 9.4 0.2 15.5 45.8 95.7 128.7 170.4 227.5 204.9 10.3 3.6 21.5-1 26.4-10.6l26.8-53.4c13.1-26.1 35.5-45.5 63.2-54.7 27.7-9.2 57.3-7.1 83.4 6.1l101 50.7c26.2 13.2 45.7 35.7 54.8 63.6 9.1 27.8 6.8 57.5-6.4 83.6-21.2 41.6-48.9 95.8-66 128.9-16.9 32.6-48.8 54.5-85.4 58.6-22.8 2.5-46 3.7-69.3 3.7zM303.1 186.3c-2 0-4.3 0.3-6.7 1.1l-125 41.5c-8.2 2.7-14 10.4-14.5 19.1-0.3 6-0.6 11.6-0.6 15.9-3.7 314.1 244.4 572.6 553.3 576.3 22.5 0.3 44.5-0.8 66.1-3.2 7.3-0.8 13.6-5.1 16.9-11.5 17-33 44.6-87 65.7-128.5 3.5-6.8 2.3-13.1 1.3-16.2-1-3.1-3.8-8.9-10.7-12.3l-101-50.7c-6.8-3.4-13-2.2-16.2-1.2-3.1 1-8.8 3.8-12.3 10.6l-26.8 53.5c-24.6 49-82.2 72.3-134.1 54.2-120.7-42.2-222-133.3-277.8-250-13.2-27.5-13.8-59.6-1.8-88 12.3-29 36.6-51.4 66.5-61.4 11.1-3.7 17.1-15.7 13.4-26.8L323 200.8c-2.4-7.2-7.7-10.8-10.6-12.3-1.8-0.9-5.1-2.2-9.3-2.2z" fill="#0a8929"></path>
                </svg>
              </span>
              <span class="order-label">联系电话<i>*</i></span>
              <input v-model.trim="orderForm.phone" class="order-control" type="tel" placeholder="请输入联系电话"/>
            </label>

            <div class="order-row">
              <span class="order-icon package-icon" aria-hidden="true">
                <svg viewBox="0 0 1024 1024" focusable="false">
                  <path d="M237.358431 284.464797l131.472334 375.310851-27.569916-19.554358L890.249275 640.22129c16.136515 0 29.212322 13.0799 29.212322 29.213345 0 16.129352-13.075807 29.205159-29.212322 29.205159L341.259826 698.639794c-12.409634 0-23.465434-7.836479-27.566846-19.549242L109.05016 94.8963l27.567869 19.553335L77.586564 114.449635c-16.129352 0-29.207206-13.074783-29.207206-29.212322 0-16.129352 13.077853-29.207206 29.207206-29.207206l59.032488 0c12.409634 0 23.466458 7.842619 27.566846 19.555381l52.728922 150.525272 710.724017 0c18.48705 0 32.326243 16.962324 28.612665 35.077913l-46.633087 227.389894c-2.547009 12.408611-12.796444 21.75549-25.382087 23.160489l-431.515944 48.065715c-16.036231 1.786693-30.482245-9.761318-32.266891-25.797549-1.783623-16.030092 9.764388-30.475082 25.798573-32.257681l410.798087-47.145763c0 0 20.75879-96.119151 35.926234-170.074513C893.311007 282.900162 362.038058 284.149619 237.358431 284.464797L237.358431 284.464797zM407.438061 818.372759c23.362081 0 42.36897 19.004843 42.36897 42.3659 0 23.360034-19.006889 42.364877-42.36897 42.364877-23.360034 0-42.363853-19.004843-42.363853-42.364877C365.073184 837.377602 384.078027 818.372759 407.438061 818.372759M407.438061 762.594385c-54.202483 0-98.142228 43.941791-98.142228 98.144274 0 54.207599 43.939745 98.143251 98.142228 98.143251s98.147344-43.936675 98.147344-98.143251C505.584382 806.536176 461.640544 762.594385 407.438061 762.594385L407.438061 762.594385zM816.372707 818.372759c23.357987 0 42.360783 19.004843 42.360783 42.3659 0 23.360034-19.002796 42.364877-42.360783 42.364877-23.360034 0-42.364877-19.004843-42.364877-42.364877C774.007831 837.377602 793.012673 818.372759 816.372707 818.372759M816.372707 762.594385c-54.206576 0-98.143251 43.941791-98.143251 98.144274 0 54.207599 43.937698 98.143251 98.143251 98.143251 54.200436 0 98.139158-43.936675 98.139158-98.143251C914.512888 806.536176 870.573143 762.594385 816.372707 762.594385L816.372707 762.594385zM816.372707 958.88191" fill="#0a8929"></path>
                </svg>
              </span>
              <span class="order-label">购买数量</span>
              <strong class="quantity-pill">{{ quantity }}台</strong>
            </div>

            <div class="order-row">
              <span class="order-icon money-icon" aria-hidden="true">
                <svg viewBox="0 0 1024 1024" focusable="false">
                  <path d="M512 64c249.6 0 448 198.4 448 448s-198.4 448-448 448-448-198.4-448-448 198.4-448 448-448z m0 64C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384zM377.6 256L512 390.4 646.4 256l44.8 44.8L544 448h128v64h-128v64h128v64h-128v128h-64v-128h-128V576h128V512h-128V448h128L332.8 300.8l44.8-44.8z" fill="#0a8929"></path>
                </svg>
              </span>
              <span class="order-label">总共金额</span>
              <strong class="amount-card">¥ {{ totalPriceText }}</strong>
            </div>

            <label class="order-row">
              <span class="order-icon location-icon" aria-hidden="true">
                <svg viewBox="0 0 1024 1024" focusable="false">
                  <path d="M511.744 68.266667c-173.5168 0-314.026667 136.311467-314.7776 305.937066 0 60.910933 18.1248 118.903467 51.7632 168.465067l3.293867 4.693333 1.911466 3.1744 1.570134 2.389334c1.058133 1.553067 2.184533 3.037867 3.447466 4.5056l0.785067 0.853333 200.174933 232.823467a68.266667 68.266667 0 0 0 103.645867-0.170667L762.641067 558.08l-1.314134 1.450667a50.346667 50.346667 0 0 0 5.341867-6.621867l1.536-2.3552c0.631467-0.989867 1.860267-3.072 1.826133-3.003733 35.293867-49.322667 55.0912-109.431467 55.825067-172.782934C825.856 204.9536 684.970667 68.266667 511.744 68.266667z m0 68.266666c135.970133 0 245.845333 106.5984 245.845333 237.824a235.400533 235.400533 0 0 1-43.9808 134.775467l-2.952533 4.676267-198.997333 232.789333-200.192-232.823467-1.928534-3.191466-0.989866-1.450667a230.229333 230.229333 0 0 1-43.3152-134.775467C265.8304 242.858667 375.415467 136.533333 511.744 136.533333z" fill="#0a8929"></path>
                  <path d="M783.803733 714.734933a34.133333 34.133333 0 0 1 45.243734 10.018134l1.4336 2.2528 73.386666 125.730133a68.266667 68.266667 0 0 1-54.784 102.5536l-4.5568 0.119467-666.043733-3.6352a68.266667 68.266667 0 0 1-60.654933-98.850134l2.133333-3.9424 69.9392-119.261866a34.133333 34.133333 0 0 1 60.16 32.170666l-1.262933 2.3552-69.9392 119.261867 666.043733 3.6352-73.386667-125.730133a34.133333 34.133333 0 0 1 12.288-46.677334z" fill="#0a8929"></path>
                  <path d="M512 243.950933a136.533333 136.533333 0 1 0 0.034133 273.1008A136.533333 136.533333 0 0 0 512 243.950933z m0 68.266667a68.266667 68.266667 0 1 1-0.034133 136.567467A68.266667 68.266667 0 0 1 512 312.2176z" fill="#0a8929"></path>
                </svg>
              </span>
              <span class="order-label">快递地址<i>*</i></span>
              <input v-model.trim="orderForm.address" class="order-control" type="text" placeholder="请输入详细的快递地址（如：省市区、街道、门牌号）"/>
            </label>

            <div v-if="hasDoctorReferral" class="order-row upload-row">
              <span class="order-icon file-icon" aria-hidden="true">
                <svg viewBox="0 0 1024 1024" focusable="false">
                  <path d="M597.333333 192l153.386667 136.32v465.706667A37.973333 37.973333 0 0 1 713.386667 832H310.613333a37.973333 37.973333 0 0 1-37.973333-37.973333V229.973333A37.973333 37.973333 0 0 1 310.613333 192H597.333333m16.213334-42.666667h-302.933334a80.64 80.64 0 0 0-80.64 80.64v564.053334A80.64 80.64 0 0 0 310.613333 874.666667h402.773334a80.64 80.64 0 0 0 80.64-80.64V309.12L614.186667 149.333333z" fill="#0a8929"></path>
                  <path d="M597.333333 341.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V170.666667a21.333333 21.333333 0 0 1 42.666667 0v149.333333a21.333333 21.333333 0 0 1-21.333334 21.333333z" fill="#0a8929"></path>
                  <path d="M768 341.333333h-170.666667a21.333333 21.333333 0 0 1 0-42.666666h170.666667a21.333333 21.333333 0 0 1 0 42.666666zM663.68 725.333333H338.986667a21.333333 21.333333 0 0 1 0-42.666666h324.693333a21.333333 21.333333 0 0 1 0 42.666666zM606.293333 597.333333H338.986667a21.333333 21.333333 0 0 1 0-42.666666h267.306666a21.333333 21.333333 0 0 1 0 42.666666zM529.92 469.333333h-190.933333a21.333333 21.333333 0 0 1 0-42.666666h192a21.333333 21.333333 0 1 1 0 42.666666z" fill="#0a8929"></path>
                </svg>
              </span>
              <span class="order-label">诊断证明</span>
              <label class="upload-card">
                <input type="file" accept="image/*" @change="handleCertificateUpload"/>
                <strong>{{ certificateUploaded ? '已成功上传' : '点击上传文件' }}</strong>
                <em>{{ certificateUploaded ? '图片已选择，订单提交时会同步处理' : '支持 JPG、PNG 格式，单个文件不超过 10MB' }}</em>
              </label>
            </div>

            <div v-if="isReferralOrder" class="order-divider"></div>

            <div v-if="hospitalDisplayText" class="order-row">
              <span class="order-icon hospital-icon" aria-hidden="true">
                <svg viewBox="0 0 1024 1024" focusable="false">
                  <path d="M462.933333 149.333333a160 160 0 0 1 159.914667 154.816l0.085333 5.184V832h155.733334a53.333333 53.333333 0 0 0 53.226666-49.834667L832 778.666667v-162.816c0-44.288-33.770667-80.213333-75.925333-82.410667L752 533.333333h-88.021333v-64h88.021333c78.037333 0 141.333333 63.04 143.936 141.504l0.085333 5.013334V778.666667a117.333333 117.333333 0 0 1-112.618666 117.248L778.666667 896h-512a117.333333 117.333333 0 0 1-117.248-112.618667L149.333333 778.666667v-512a117.333333 117.333333 0 0 1 112.618667-117.248L266.666667 149.333333h196.266666z m0 64h-196.266666a53.333333 53.333333 0 0 0-53.226667 49.834667L213.333333 266.666667v512a53.333333 53.333333 0 0 0 49.834667 53.226666L266.666667 832h292.266666V309.333333a96 96 0 0 0-86.890666-95.573333l-4.586667-0.32L462.933333 213.333333z m-78.186666 60.8a32 32 0 0 1 31.850666 28.906667l0.149334 3.072-0.021334 43.392h43.413334a32 32 0 0 1 3.072 63.872l-3.072 0.149333-43.413334-0.021333v43.413333a32 32 0 0 1-63.850666 3.093334l-0.128-3.093334-0.021334-43.413333H309.333333a32 32 0 0 1-3.072-63.850667l3.072-0.128 43.392-0.021333v-43.392a32 32 0 0 1 32-32z" fill="#0a8929"></path>
                </svg>
              </span>
              <span class="order-label">下单医院</span>
              <span class="readonly-card">{{ hospitalDisplayText }}</span>
            </div>

            <div v-if="doctorDisplayText" class="order-row">
              <span class="order-icon doctor-icon" aria-hidden="true">
                <svg viewBox="0 0 1024 1024" focusable="false">
                  <path d="M563.2 179.2h-25.6v-25.6c0-12.8-12.8-25.6-25.6-25.6s-25.6 12.8-25.6 25.6v25.6h-25.6c-12.8 0-25.6 12.8-25.6 25.6s12.8 25.6 25.6 25.6h25.6v25.6c0 12.8 12.8 25.6 25.6 25.6s25.6-12.8 25.6-25.6v-25.6h25.6c12.8 0 25.6-12.8 25.6-25.6s-12.8-25.6-25.6-25.6z" fill="#0a8929"></path>
                  <path d="M686.08 596.48c51.2-46.08 81.92-112.64 81.92-186.88V117.76c0-10.24-5.12-20.48-15.36-23.04-33.28-12.8-122.88-43.52-240.64-43.52s-204.8 30.72-240.64 43.52c-10.24 5.12-15.36 12.8-15.36 23.04v281.6c0 76.8 33.28 145.92 84.48 197.12-135.68 30.72-238.08 153.6-238.08 299.52 0 43.52 33.28 76.8 76.8 76.8h665.6c43.52 0 76.8-33.28 76.8-76.8 0-145.92-99.84-266.24-235.52-299.52z m-174.08 296.96l-87.04-69.12-87.04-64 33.28-81.92 145.92 212.48-5.12 2.56z m-102.4-250.88c25.6 12.8 53.76 20.48 84.48 20.48h17.92c35.84 0 71.68-7.68 102.4-23.04l-99.84 151.04-104.96-148.48z m135.68 197.12l107.52-161.28 33.28 79.36-87.04 66.56-40.96 33.28-12.8-17.92z m-238.08-442.88c48.64-17.92 117.76-38.4 204.8-38.4 25.6 0 48.64 2.56 74.24 5.12 12.8 2.56 28.16-7.68 28.16-23.04 2.56-12.8-7.68-28.16-23.04-28.16-25.6-2.56-53.76-5.12-79.36-5.12-87.04 0-161.28 20.48-204.8 35.84v-207.36c38.4-12.8 110.08-33.28 204.8-33.28s166.4 20.48 204.8 33.28v207.36c-7.68-2.56-17.92-5.12-28.16-10.24-12.8-5.12-28.16 2.56-30.72 17.92-5.12 12.8 2.56 28.16 17.92 30.72 15.36 5.12 30.72 10.24 43.52 15.36v12.8c0 112.64-92.16 204.8-204.8 204.8h-12.8c-107.52-7.68-192-99.84-192-212.48v-5.12z m-153.6 499.2c0-112.64 71.68-207.36 171.52-240.64l-33.28 84.48c-7.68 20.48-2.56 46.08 17.92 58.88l87.04 64 71.68 56.32H179.2c-15.36 2.56-25.6-7.68-25.6-23.04z m691.2 25.6h-243.2l-15.36-23.04 43.52-33.28 87.04-64c17.92-12.8 25.6-38.4 17.92-58.88l-33.28-84.48c99.84 35.84 171.52 130.56 171.52 240.64-2.56 12.8-12.8 23.04-28.16 23.04z" fill="#0a8929"></path>
                </svg>
              </span>
              <span class="order-label">下单医生</span>
              <span class="readonly-card">{{ doctorDisplayText }}</span>
            </div>

          </div>

          <div class="dialog-footer">
            <span class="privacy-note">我们将严格保护您的个人信息安全</span>
            <div class="dialog-actions">
              <button type="button" class="dialog-cancel" @click="closeOrderDialog">取消</button>
              <button
                type="button"
                class="dialog-submit"
                :disabled="submittingOrder || isOrderCooldownActive"
                @click="submitOrder"
              >
                {{ submitButtonText }}
              </button>
            </div>
          </div>
          </template>
        </div>
      </div>
    </transition>

    <transition name="modal-fade">
      <div v-if="isOrderCooldownActive" class="success-popup" role="status" aria-live="polite">
        <strong>已成功下单</strong>
        <span>{{ orderSuccessCountdown }} 秒后可再次提交</span>
      </div>
    </transition>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { createNativePrepay, getGoodsDetail, queryNativePayByOutTradeNo } from '@/api/pay'
import { getSalespersonBindList } from '@/api/salesperson'

const GOODS_CODE = {
  referral: 'SYXQ-V1.0-MED',
  default: 'SYXQ-V1.0-AGENCY'
}

const GOODS_DETAIL_ID = {
  [GOODS_CODE.referral]: 2,
  [GOODS_CODE.default]: 3
}

const PAYMENT_POLL_INTERVAL = 2000
const PAYMENT_POLL_TIMEOUT = 5 * 60 * 1000

export default {
  name: 'BuyPage',
  data() {
    return {
      quantity: 1,
      currentImageIndex: 0,
      productCarouselTimer: null,
      productImages: [
        {
          src: require('@/assets/img/buy/box4.png'),
          alt: '产品图 1'
        },
        {
          src: require('@/assets/img/buy/box1.png'),
          alt: '产品图 2'
        },
        {
          src: require('@/assets/img/buy/box2.png'),
          alt: '产品图 3'
        },
        {
          src: require('@/assets/img/buy/box3.png'),
          alt: '产品图 4'
        }
      ],
      showOrderDialog: false,
      certificateUploaded: false,
      submittingOrder: false,
      paymentCodeUrl: '',
      paymentQrCode: '',
      paymentOutTradeNo: '',
      paymentQueryTimer: null,
      orderSuccessCountdown: 0,
      orderSuccessTimer: null,
      goodsLoading: false,
      goodsLoadError: '',
      currentGoods: {
        id: '',
        name: '',
        code: '',
        price: 0,
        stock: 0
      },
      referralLoading: false,
      referralLoadError: '',
      referralInfo: {
        type: '',
        typeName: '',
        salesId: '',
        hospitalId: '',
        hospitalName: '',
        doctorId: '',
        doctorName: ''
      },
      orderForm: {
        customerName: '',
        phone: '',
        address: '',
        type: '',
        typeName: '',
        salesId: '',
        hospitalId: '',
        doctorId: ''
      }
    }
  },
  created() {
    this.setReferralFromQuery(this.$route.query)
  },
  mounted() {
    this.startProductCarousel()
  },
  beforeDestroy() {
    this.stopProductCarousel()
    this.clearOrderCooldownTimer()
    this.clearPaymentPolling()
  },
  watch: {
    '$route.query'(query) {
      this.setReferralFromQuery(query)
    }
  },
  computed: {
    currentProductImage() {
      return this.productImages[this.currentImageIndex] || this.productImages[0]
    },
    totalPriceText() {
      return (this.currentGoodsPrice * this.quantity).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    isReferralOrder() {
      return Boolean(this.hospitalDisplayText || this.doctorDisplayText)
    },
    referralTypeKey() {
      const type = String(this.referralInfo.type || '').toLowerCase()

      if (type) {
        return type
      }

      if (this.referralInfo.typeName === '医院') {
        return 'hospital'
      }

      if (this.referralInfo.typeName === '医生') {
        return 'doctor'
      }

      if (this.referralInfo.doctorId) {
        return 'doctor'
      }

      if (this.referralInfo.hospitalId) {
        return 'hospital'
      }

      if (this.referralInfo.salesId) {
        return 'sales'
      }

      return ''
    },
    isHospitalReferral() {
      return this.referralTypeKey === 'hospital'
    },
    isDoctorReferral() {
      return this.referralTypeKey === 'doctor'
    },
    currentGoodsCode() {
      return this.hasFullReferralInfo ? GOODS_CODE.referral : GOODS_CODE.default
    },
    currentGoodsDetailId() {
      return GOODS_DETAIL_ID[this.currentGoodsCode] || ''
    },
    currentGoodsId() {
      return this.currentGoods.id
    },
    currentGoodsPrice() {
      const price = Number(this.currentGoods.price)

      return Number.isNaN(price) ? 0 : price
    },
    isOrderCooldownActive() {
      return this.orderSuccessCountdown > 0
    },
    submitButtonText() {
      if (this.submittingOrder) {
        return '生成中'
      }

      if (this.isOrderCooldownActive) {
        return `${this.orderSuccessCountdown}秒后可提交`
      }

      return '确认支付'
    },
    hasFullReferralInfo() {
      return Boolean(
        this.orderForm.salesId &&
        this.orderForm.hospitalId &&
        this.orderForm.doctorId
      )
    },
    hasDoctorReferral() {
      return Boolean(this.isDoctorReferral && this.referralInfo.doctorId)
    },
    hospitalDisplayText() {
      if (!this.isHospitalReferral && !this.isDoctorReferral) {
        return ''
      }

      if (this.referralInfo.hospitalName) {
        return this.referralInfo.hospitalName
      }

      return this.referralInfo.hospitalId ? `医院ID：${this.referralInfo.hospitalId}` : ''
    },
    doctorDisplayText() {
      if (!this.isHospitalReferral && !this.isDoctorReferral) {
        return ''
      }

      if (this.referralInfo.doctorName) {
        return this.referralInfo.doctorName
      }

      return this.referralInfo.doctorId ? `医生ID：${this.referralInfo.doctorId}` : ''
    }
  },
  methods: {
    decrease() {
      if (this.quantity > 1) {
        this.quantity -= 1
      }
    },
    increase() {
      this.quantity += 1
    },
    handleDialogOverlayClick() {
      if (this.paymentQrCode) {
        return
      }

      this.closeOrderDialog()
    },
    closeOrderDialog() {
      this.clearPaymentPolling()
      this.showOrderDialog = false
      this.paymentCodeUrl = ''
      this.paymentQrCode = ''
      this.paymentOutTradeNo = ''
    },
    cancelPayment() {
      this.closeOrderDialog()
    },
    goToProductImage(index) {
      this.currentImageIndex = index
      this.restartProductCarousel()
    },
    showNextProductImage(shouldRestart = false) {
      const imageCount = this.productImages.length

      if (imageCount <= 1) {
        return
      }

      this.currentImageIndex = (this.currentImageIndex + 1) % imageCount

      if (shouldRestart) {
        this.restartProductCarousel()
      }
    },
    startProductCarousel() {
      if (this.productCarouselTimer || this.productImages.length <= 1) {
        return
      }

      this.productCarouselTimer = window.setInterval(() => {
        this.showNextProductImage()
      }, 3000)
    },
    stopProductCarousel() {
      if (!this.productCarouselTimer) {
        return
      }

      window.clearInterval(this.productCarouselTimer)
      this.productCarouselTimer = null
    },
    restartProductCarousel() {
      this.stopProductCarousel()
      this.startProductCarousel()
    },
    handleCertificateUpload(event) {
      this.certificateUploaded = event.target.files && event.target.files.length > 0
    },
    async submitOrder() {
      if (this.isOrderCooldownActive) {
        return
      }

      const errorMessage = this.getOrderFormError()

      if (errorMessage) {
        window.alert(errorMessage)
        return
      }

      if (this.submittingOrder) {
        return
      }

      this.submittingOrder = true
      this.paymentCodeUrl = ''
      this.paymentQrCode = ''
      this.paymentOutTradeNo = ''
      this.clearPaymentPolling()

      try {
        const response = await createNativePrepay(this.getPrepayParams())
        const paymentData = response && response.data ? response.data : response
        const codeUrl = paymentData && (paymentData.code_url || paymentData.codeUrl)
        const outTradeNo = paymentData && (paymentData.outTradeNo || paymentData.out_trade_no)

        if (!codeUrl) {
          throw new Error('预下单接口未返回 code_url')
        }

        if (!outTradeNo) {
          throw new Error('预下单接口未返回 outTradeNo')
        }

        this.paymentCodeUrl = codeUrl
        this.paymentOutTradeNo = outTradeNo
        this.paymentQrCode = await QRCode.toDataURL(codeUrl, {
          width: 220,
          margin: 1,
          errorCorrectionLevel: 'M'
        })
        this.startPaymentPolling(outTradeNo)
      } catch (error) {
        window.alert(error && error.message ? error.message : '支付预下单失败')
      } finally {
        this.submittingOrder = false
      }
    },
    startPaymentPolling(outTradeNo) {
      const startTime = Date.now()

      this.clearPaymentPolling()

      const pollPaymentStatus = async () => {
        if (!this.paymentOutTradeNo || this.paymentOutTradeNo !== outTradeNo) {
          return
        }

        try {
          const response = await queryNativePayByOutTradeNo(outTradeNo)
          const paymentStatus = this.getPaymentStatus(response)

          if (paymentStatus === 'success') {
            this.handlePaymentFinished('支付成功', true)
            return
          }

          if (paymentStatus === 'failed') {
            this.handlePaymentFinished('支付失败')
            return
          }
        } catch (error) {
          console.error('支付结果查询失败', error)
        }

        if (!this.paymentOutTradeNo || this.paymentOutTradeNo !== outTradeNo) {
          return
        }

        if (Date.now() - startTime >= PAYMENT_POLL_TIMEOUT) {
          this.handlePaymentFinished('支付失败')
          return
        }

        this.paymentQueryTimer = window.setTimeout(pollPaymentStatus, PAYMENT_POLL_INTERVAL)
      }

      this.paymentQueryTimer = window.setTimeout(pollPaymentStatus, PAYMENT_POLL_INTERVAL)
    },
    clearPaymentPolling() {
      if (!this.paymentQueryTimer) {
        return
      }

      window.clearTimeout(this.paymentQueryTimer)
      this.paymentQueryTimer = null
    },
    handlePaymentFinished(message, shouldResetUserInput = false) {
      this.clearPaymentPolling()
      if (shouldResetUserInput) {
        this.resetUserOrderInput()
      }
      window.alert(message)
      this.closeOrderDialog()
    },
    resetUserOrderInput() {
      this.orderForm.customerName = ''
      this.orderForm.phone = ''
      this.orderForm.address = ''
      this.certificateUploaded = false
    },
    getPaymentStatus(response) {
      const paymentData = response && Object.prototype.hasOwnProperty.call(response, 'data')
        ? response.data
        : response
      const statusValue = this.findPaymentStatusValue(paymentData)

      if (this.isPaymentSuccessStatus(statusValue)) {
        return 'success'
      }

      if (this.isPaymentFailedStatus(statusValue)) {
        return 'failed'
      }

      return 'pending'
    },
    findPaymentStatusValue(data) {
      if (data === null || data === undefined) {
        return ''
      }

      if (typeof data !== 'object') {
        return data
      }

      const directStatusKeys = [
        'tradeState',
        'trade_state',
        'payStatus',
        'pay_status',
        'paymentStatus',
        'payment_status',
        'orderStatus',
        'order_status',
        'status',
        'state'
      ]
      const directBooleanKeys = [
        'paid',
        'isPaid',
        'is_paid',
        'paySuccess',
        'pay_success',
        'paymentSuccess',
        'payment_success'
      ]

      for (const key of directBooleanKeys) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          return data[key] === true ? 'SUCCESS' : ''
        }
      }

      for (const key of directStatusKeys) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          return data[key]
        }
      }

      const nestedKeys = ['data', 'result', 'order', 'payment', 'payInfo']

      for (const key of nestedKeys) {
        if (data[key] && typeof data[key] === 'object') {
          const nestedStatus = this.findPaymentStatusValue(data[key])

          if (nestedStatus !== '') {
            return nestedStatus
          }
        }
      }

      return ''
    },
    isPaymentSuccessStatus(value) {
      if (value === true || value === 1) {
        return true
      }

      const status = String(value || '').trim().toUpperCase()

      return [
        '1',
        'SUCCESS',
        'PAID',
        'PAY_SUCCESS',
        'PAYED',
        'TRADE_SUCCESS',
        '支付成功',
        '已支付'
      ].includes(status)
    },
    isPaymentFailedStatus(value) {
      const status = String(value || '').trim().toUpperCase()

      return [
        'FAIL',
        'FAILED',
        'PAY_FAIL',
        'PAY_FAILED',
        'PAYERROR',
        'CLOSED',
        'REVOKED',
        'REFUND',
        'CANCEL',
        'CANCELED',
        'CANCELLED',
        'TIMEOUT',
        'EXPIRED',
        '支付失败',
        '已关闭',
        '已取消'
      ].includes(status)
    },
    startOrderCooldown() {
      this.clearOrderCooldownTimer()
      this.orderSuccessCountdown = 10
      this.orderSuccessTimer = window.setInterval(() => {
        this.orderSuccessCountdown -= 1

        if (this.orderSuccessCountdown <= 0) {
          this.orderSuccessCountdown = 0
          this.clearOrderCooldownTimer()
        }
      }, 1000)
    },
    clearOrderCooldownTimer() {
      if (!this.orderSuccessTimer) {
        return
      }

      window.clearInterval(this.orderSuccessTimer)
      this.orderSuccessTimer = null
    },
    getPrepayParams() {
      return this.removeEmptyValues({
        count: this.quantity,
        goodId: this.toNumberOrEmpty(this.currentGoodsId),
        doctorId: this.toNumberOrDefault(this.orderForm.doctorId, -1),
        hospitalId: this.toNumberOrDefault(this.orderForm.hospitalId, -1),
        salesId: this.toNumberOrDefault(this.orderForm.salesId, -1),
        receiverPhone: this.orderForm.phone,
        receiverName: this.orderForm.customerName,
        receiverAddress: this.orderForm.address
      })
    },
    removeEmptyValues(data) {
      return Object.keys(data).reduce((result, key) => {
        const value = data[key]

        if (value !== '' && value !== null && value !== undefined) {
          result[key] = value
        }

        return result
      }, {})
    },
    toNumberOrEmpty(value) {
      if (value === '' || value === null || value === undefined) {
        return ''
      }

      const numberValue = Number(value)

      return Number.isNaN(numberValue) ? '' : numberValue
    },
    toNumberOrDefault(value, defaultValue) {
      const numberValue = this.toNumberOrEmpty(value)

      return numberValue === '' ? defaultValue : numberValue
    },
    getOrderFormError() {
      const mobilePhonePattern = /^1[3-9]\d{9}$/

      if (!this.orderForm.customerName) {
        return '请输入下单人姓名'
      }

      if (!this.orderForm.phone) {
        return '请输入联系电话'
      }

      if (!mobilePhonePattern.test(this.orderForm.phone)) {
        return '请输入正确的手机号'
      }

      if (!this.orderForm.address) {
        return '请输入快递地址'
      }

      if (this.goodsLoading) {
        return '商品信息加载中，请稍后再试'
      }

      if (!this.currentGoodsId) {
        return '商品信息获取失败，请刷新后重试'
      }

      return ''
    },
    setReferralFromQuery(query = {}) {
      const normalizedQuery = this.getNormalizedQuery(query)
      const type = this.getQueryValue(normalizedQuery.type)
      const typeName = this.getQueryValue(normalizedQuery.typename)
      const salesId = this.getQueryValue(normalizedQuery.salesid)
      const hospitalId = this.getQueryValue(normalizedQuery.hospitalid)
      const doctorId = this.getQueryValue(normalizedQuery.doctorid)

      this.referralInfo = {
        type,
        typeName,
        salesId,
        hospitalId,
        hospitalName: '',
        doctorId,
        doctorName: ''
      }
      this.orderForm.type = type
      this.orderForm.typeName = typeName
      this.orderForm.salesId = salesId
      this.orderForm.hospitalId = hospitalId
      this.orderForm.doctorId = doctorId

      if (!this.isDoctorReferral) {
        this.certificateUploaded = false
      }

      this.loadReferralBindInfo()
      this.loadCurrentGoods()
    },
    async loadCurrentGoods() {
      const code = this.currentGoodsCode
      const goodsDetailId = this.currentGoodsDetailId

      if (!code || !goodsDetailId) {
        return
      }

      this.goodsLoading = true
      this.goodsLoadError = ''
      this.currentGoods = {
        id: '',
        name: '',
        code,
        price: 0,
        stock: 0
      }

      try {
        const response = await getGoodsDetail(goodsDetailId)
        const goods = response && response.data ? response.data : response

        if (!goods || typeof goods !== 'object') {
          this.goodsLoadError = '商品信息获取失败'
          return
        }

        this.currentGoods = {
          id: goods.id,
          name: goods.name || '',
          code: goods.code || code,
          price: goods.price || 0,
          stock: goods.stock || 0
        }
        console.log('[Buy] 商品价格接口返回', {
          code,
          goodsDetailId,
          response,
          price: this.currentGoods.price
        })
      } catch (error) {
        this.goodsLoadError = error && error.message ? error.message : '商品信息获取失败'
        console.error('商品信息获取失败', error)
      } finally {
        this.goodsLoading = false
      }
    },
    async loadReferralBindInfo() {
      const params = this.getReferralBindParams()

      if (!Object.keys(params).length) {
        return
      }

      this.referralLoading = true
      this.referralLoadError = ''

      try {
        const response = await getSalespersonBindList(params)
        const bindItem = this.findReferralBindItem(response)

        if (!bindItem) {
          this.referralLoadError = '未匹配到医院医生绑定信息'
          console.warn('未匹配到医院医生绑定信息', {
            params,
            response
          })
          return
        }

        this.referralInfo.hospitalName = this.getQueryValue(bindItem.hospitalName)
        this.referralInfo.doctorName = this.getQueryValue(bindItem.doctorName)
      } catch (error) {
        this.referralInfo.hospitalName = ''
        this.referralInfo.doctorName = ''
        this.referralLoadError = error && error.message ? error.message : '医院医生信息获取失败'
        console.error('医院医生信息获取失败', error)
      } finally {
        this.referralLoading = false
      }
    },
    findReferralBindItem(response) {
      const list = this.getReferralBindList(response)
      const { salesId, hospitalId, doctorId } = this.referralInfo

      if (this.isHospitalReferral) {
        const exactItem = list.find((item) => {
          return this.isExpectedId(item.salesId, salesId) &&
            this.isExpectedId(item.hospitalId, hospitalId) &&
            this.isExpectedId(item.doctorId, doctorId)
        })

        if (exactItem) {
          return exactItem
        }

        return list.find((item) => {
          return this.isExpectedId(item.hospitalId, hospitalId) &&
            this.isExpectedId(item.doctorId, doctorId)
        }) || list.find((item) => {
          return this.isExpectedId(item.hospitalId, hospitalId)
        }) || list[0]
      }

      if (this.isDoctorReferral) {
        return list.find((item) => this.isExpectedId(item.doctorId, doctorId))
      }

      if (this.referralTypeKey === 'sales') {
        return list.find((item) => this.isExpectedId(item.salesId, salesId))
      }

      return list.find((item) => {
        return this.isExpectedId(item.salesId, salesId) &&
          this.isExpectedId(item.hospitalId, hospitalId) &&
          this.isExpectedId(item.doctorId, doctorId)
      })
    },
    getReferralBindParams() {
      const { salesId, hospitalId, doctorId } = this.referralInfo

      if (this.referralTypeKey === 'other') {
        return {}
      }

      if (this.isHospitalReferral) {
        return {
          ...(salesId ? { salesId } : {}),
          ...(hospitalId ? { hospitalId } : {}),
          ...(doctorId ? { doctorId } : {})
        }
      }

      if (this.isDoctorReferral) {
        return doctorId ? { doctorId } : {}
      }

      if (this.referralTypeKey === 'sales') {
        return salesId ? { salesId } : {}
      }

      return {
        ...(salesId ? { salesId } : {}),
        ...(hospitalId ? { hospitalId } : {}),
        ...(doctorId ? { doctorId } : {})
      }
    },
    getReferralBindList(response) {
      if (Array.isArray(response)) {
        return response
      }

      const data = response && response.data ? response.data : response

      if (Array.isArray(data)) {
        return data
      }

      if (data && Array.isArray(data.list)) {
        return data.list
      }

      if (data && Array.isArray(data.records)) {
        return data.records
      }

      if (data && Array.isArray(data.rows)) {
        return data.rows
      }

      return []
    },
    isExpectedId(actual, expected) {
      return !expected || String(actual || '') === String(expected)
    },
    getNormalizedQuery(query = {}) {
      const normalizedQuery = {}

      Object.keys(query || {}).forEach((key) => {
        normalizedQuery[String(key).toLowerCase()] = query[key]
      })

      if (typeof window !== 'undefined' && window.location && window.location.search) {
        const searchParams = new URLSearchParams(window.location.search)

        searchParams.forEach((value, key) => {
          const normalizedKey = String(key).toLowerCase()

          if (!normalizedQuery[normalizedKey]) {
            normalizedQuery[normalizedKey] = value
          }
        })
      }

      return normalizedQuery
    },
    getQueryValue(value) {
      if (Array.isArray(value)) {
        return value[0] ? this.normalizeQueryValue(value[0]) : ''
      }

      return value ? this.normalizeQueryValue(value) : ''
    },
    normalizeQueryValue(value) {
      const text = String(value).trim()

      try {
        return decodeURIComponent(text)
      } catch (error) {
        return text
      }
    }
  }
}
</script>

<style scoped>
.buy-page {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px clamp(20px, 2.5vw, 48px);
  background: #f6fbf7;
  color: #111827;
  box-sizing: border-box;
}

.product-detail {
  position: relative;
  width: min(1890px, 100%);
  min-height: calc(100vh - var(--jhy-header-h, 64px) - 100px);
  margin: 0 auto;
  padding: 44px 64px 40px;
  display: grid;
  grid-template-columns: minmax(380px, 560px) minmax(0, 590px);
  column-gap: 54px;
  row-gap: 32px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: #ffffff;
  //border-top: 1px solid #f2f2f2;
}

.product-media {
  grid-column: 1;
}

.product-info {
  grid-column: 2;
  padding-top: 4px;
}

.product-info h1 {
  margin: 0 0 20px;
  font-size: 36px;
  line-height: 1.25;
  font-weight: 800;
  letter-spacing: 0;
  color: #111827;
}

.price-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 28px;
}

.currency {
  font-size: 30px;
  font-weight: 800;
}

.price {
  font-size: 38px;
  font-weight: 800;
}

.description {
  max-width: 500px;
  margin: 0 0 30px;
  color: #111827;
  font-size: 15px;
  line-height: 1.95;
}

.action-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 24px 0 42px;
}

.quantity-control {
  width: 132px;
  height: 44px;
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  border: 1px solid #d1d5db;
  border-radius: 2px;
  background: #f4f5f7;
  overflow: hidden;
}

.quantity-control button {
  border: none;
  background: transparent;
  color: #111827;
  font-size: 19px;
  line-height: 1;
  cursor: pointer;
}

.quantity-control span {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111827;
  font-size: 15px;
  font-weight: 700;
}

.buy-button {
  width: 166px;
  height: 44px;
  border: none;
  border-radius: 2px;
  background: #55b77c;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.buy-button:hover {
  background: #43a86d;
}

.service-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 15px;
  color: #6b7280;
  font-size: 14px;
}

.service-row span + span::before {
  content: "•";
  margin-right: 15px;
  color: #9ca3af;
}

.product-media {
  display: grid;
  gap: 22px;
}

.product-carousel {
  position: relative;
  width: 100%;
}

.main-product-image {
  width: 100%;
  height: 430px;
  overflow: hidden;
  background: #ffffff;
}

.carousel-track {
  height: 100%;
  display: flex;
  transition: transform 0.35s ease;
  will-change: transform;
}

.carousel-slide {
  width: 100%;
  height: 100%;
  flex: 0 0 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.carousel-dots {
  position: absolute;
  left: 50%;
  bottom: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 8px;
  transform: translateX(-50%);
}

.carousel-dot {
  width: 8px;
  height: 8px;
  border: none;
  border-radius: 50%;
  padding: 0;
  background: rgba(17, 24, 39, 0.24);
  cursor: pointer;
}

.carousel-dot.active {
  width: 20px;
  border-radius: 999px;
  background: #55b77c;
}

.thumb-list {
  display: grid;
  grid-template-columns: repeat(4, 88px);
  gap: 18px;
  justify-content: start;
}

.thumb {
  width: 88px;
  height: 88px;
  border: 1px solid #e5e7eb;
  padding: 0;
  overflow: hidden;
  background: #ffffff;
  cursor: pointer;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.thumb.active {
  border-color: #55b77c;
  box-shadow: inset 0 0 0 1px #55b77c;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.46);
}

.order-dialog {
  position: relative;
  width: min(560px, calc(100vw - 48px));
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
  box-sizing: border-box;
}

.order-dialog.qr-dialog {
  width: min(300px, calc(100vw - 48px));
  min-height: 300px;
  max-height: none;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.payment-qr-only {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

.payment-qr-only img {
  width: min(220px, 100%);
  height: auto;
  display: block;
}

.payment-qr-only p {
  margin: 0;
  color: #4b5563;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
}

.payment-cancel-button {
  width: 100%;
  height: 38px;
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  background: #ffffff;
  color: #4b5563;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.payment-cancel-button:hover {
  border-color: #0a8929;
  color: #0a8929;
}

.dialog-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  z-index: 2;
}

.dialog-header {
  min-height: 96px;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  padding: 28px 30px 18px;
  background: linear-gradient(135deg, #f8fffb 0%, #ffffff 64%);
  box-sizing: border-box;
}

.dialog-header h2 {
  margin: 0 0 8px;
  color: #0f172a;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 800;
}

.dialog-header p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.6;
}

.order-form {
  display: grid;
  gap: 16px;
  padding: 4px 30px 22px;
  overflow-y: auto;
  box-sizing: border-box;
}

.order-row {
  display: grid;
  grid-template-columns: 30px 88px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-height: 42px;
}

.upload-row {
  align-items: start;
}

.order-icon {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e9f8ef;
  border-radius: 50%;
  color: #35a66d;
  font-size: 14px;
  font-weight: 700;
}

.order-icon::before {
  content: "+";
  line-height: 1;
}

.user-icon,
.phone-icon,
.package-icon,
.money-icon,
.location-icon,
.file-icon,
.hospital-icon,
.doctor-icon {
  background: transparent;
}

.user-icon::before,
.phone-icon::before,
.package-icon::before,
.money-icon::before,
.location-icon::before,
.file-icon::before,
.hospital-icon::before,
.doctor-icon::before {
  content: none;
}

.user-icon svg,
.phone-icon svg,
.package-icon svg,
.money-icon svg,
.location-icon svg,
.file-icon svg,
.hospital-icon svg,
.doctor-icon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.file-icon svg {
  width: 112%;
  height: 112%;
}

.file-icon path {
  stroke: #0a8929;
  stroke-width: 14;
  stroke-linejoin: round;
  stroke-linecap: round;
}

.order-label {
  color: #1f2937;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}

.order-label i {
  margin-left: 2px;
  color: #ef4444;
  font-style: normal;
}

.order-control,
.readonly-card {
  width: 100%;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #e1e7ef;
  border-radius: 6px;
  background: #ffffff;
  color: #111827;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
}

.order-control:focus {
  border-color: #55b77c;
  box-shadow: 0 0 0 3px rgba(85, 183, 124, 0.12);
}

.order-control::placeholder {
  color: #a8b1bf;
}

.quantity-pill {
  width: fit-content;
  min-width: 66px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background: #e9f8ef;
  border-radius: 6px;
  color: #179153;
  font-size: 15px;
  font-weight: 800;
  box-sizing: border-box;
}

.amount-card {
  min-height: 52px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: linear-gradient(90deg, #e6f8ed, #f7fcfa);
  border-radius: 6px;
  color: #169454;
  font-size: 24px;
  font-weight: 800;
  box-sizing: border-box;
}

.upload-card {
  min-height: 106px;
  display: grid;
  justify-items: center;
  align-content: center;
  gap: 8px;
  padding: 16px;
  border: 1px dashed #8fd9b1;
  border-radius: 6px;
  background: #f5fffa;
  color: #35a66d;
  cursor: pointer;
  box-sizing: border-box;
}

.upload-card input {
  display: none;
}

.upload-card strong {
  min-width: 122px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #55b77c;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
}

.upload-card em {
  color: #7b8794;
  font-size: 11px;
  font-style: normal;
  line-height: 1.5;
  text-align: center;
}

.order-divider {
  height: 1px;
  margin: 2px 0 0 42px;
  background: #edf2f7;
}

.readonly-card {
  display: flex;
  align-items: center;
  border-color: transparent;
  background: #f1f4f8;
  color: #4b5563;
  font-weight: 700;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 30px 18px;
  border-top: 1px solid #edf2f7;
  background: #ffffff;
}

.privacy-note {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #7b8794;
  font-size: 11px;
  line-height: 1.4;
}

.privacy-note::before {
  content: "◇";
  color: #64748b;
  font-size: 14px;
}

.dialog-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 0 0 auto;
}

.dialog-actions button {
  width: 88px;
  height: 40px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.dialog-cancel {
  border: 1px solid #dbe3ec;
  background: #ffffff;
  color: #4b5563;
}

.dialog-submit {
  border: 1px solid #55b77c;
  background: #55b77c;
  color: #ffffff;
}

.dialog-submit:hover {
  background: #43a86d;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.success-popup {
  position: fixed;
  top: calc(var(--jhy-header-h, 64px) + 18px);
  left: 50%;
  z-index: 1300;
  min-width: 220px;
  display: grid;
  gap: 5px;
  padding: 14px 18px;
  border: 1px solid #b9ebce;
  border-radius: 8px;
  background: #f2fff7;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.16);
  color: #166534;
  text-align: center;
  transform: translateX(-50%);
}

.success-popup strong {
  font-size: 15px;
  line-height: 1.35;
}

.success-popup span {
  color: #4b5563;
  font-size: 12px;
  line-height: 1.45;
}

@media (max-width: 900px) {
  .product-detail {
    grid-template-columns: 1fr;
    justify-content: stretch;
    gap: 32px;
    padding-top: 32px;
  }

  .product-media {
    grid-column: auto;
    order: -1;
  }

  .product-info {
    grid-column: auto;
  }

  .thumb-list {
    justify-content: start;
  }
}

@media (max-width: 767px) {
  .buy-page {
    min-height: calc(100vh - 56px);
    align-items: flex-start;
    padding: 24px 0;
  }

  .product-detail {
    min-height: auto;
    padding: 20px 16px 28px;
    gap: 26px;
  }

  .product-info h1 {
    font-size: 28px;
    margin-bottom: 14px;
  }

  .price-row {
    margin-bottom: 20px;
  }

  .price {
    font-size: 26px;
  }

  .description {
    margin-bottom: 34px;
    font-size: 15px;
    line-height: 1.8;
  }

  .main-product-image {
    height: auto;
    aspect-ratio: 1.24 / 1;
  }

  .thumb-list {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
  }

  .thumb {
    width: 100%;
  }

  .action-row {
    display: grid;
    grid-template-columns: 132px 1fr;
    gap: 12px;
    margin: 26px 0 22px;
  }

  .quantity-control {
    width: 132px;
  }

  .buy-button {
    width: 100%;
  }

  .service-row {
    display: flex;
    flex-wrap: nowrap;
    gap: 6px 10px;
    font-size: 14px;
  }

  .service-row span + span::before {
    content: none;
    margin-right: 0;
  }

  .modal-overlay {
    align-items: center;
    justify-content: center;
    height: 100vh;
    height: 100dvh;
    padding: 12px;
    overflow: hidden;
  }

  .order-dialog {
    width: min(430px, calc(100vw - 24px));
    height: calc(100vh - 24px);
    height: calc(100dvh - 24px);
    max-height: 680px;
    border-radius: 12px;
  }

  .order-dialog.qr-dialog {
    width: min(300px, calc(100vw - 24px));
    height: auto;
    min-height: 276px;
    max-height: none;
    padding: 20px;
  }

  .order-dialog::before {
    content: none;
  }

  .dialog-close {
    top: 12px;
    right: 12px;
    width: 30px;
    height: 30px;
    font-size: 24px;
  }

  .dialog-header {
    min-height: auto;
    padding: 18px 48px 10px 16px;
    background: #ffffff;
    flex: 0 0 auto;
  }

  .dialog-header h2 {
    margin-bottom: 4px;
    font-size: 20px;
  }

  .dialog-header p {
    font-size: 11px;
    line-height: 1.5;
  }

  .order-form {
    flex: 1 1 0;
    min-height: 0;
    align-content: start;
    grid-auto-rows: max-content;
    gap: 14px;
    padding: 6px 16px 18px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  .order-row {
    grid-template-columns: 26px minmax(0, 1fr);
    gap: 8px 10px;
    min-height: 0;
    align-items: start;
  }

  .order-icon {
    width: 24px;
    height: 24px;
    font-size: 13px;
  }

  .order-label {
    min-height: 24px;
    display: flex;
    align-items: center;
    font-size: 13px;
  }

  .order-control,
  .quantity-pill,
  .amount-card,
  .upload-card,
  .readonly-card {
    grid-column: 1 / -1;
    min-width: 0;
  }

  .order-control,
  .readonly-card {
    height: 42px;
    padding: 0 12px;
    font-size: 12px;
  }

  .readonly-card {
    height: auto;
    min-height: 42px;
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 1.45;
  }

  .amount-card {
    min-height: 52px;
    padding: 0 12px;
    font-size: 20px;
  }

  .quantity-pill {
    height: 36px;
    min-width: 64px;
    font-size: 14px;
  }

  .upload-card {
    min-height: 112px;
    padding: 12px 10px;
    gap: 6px;
  }

  .upload-card strong {
    height: 32px;
  }

  .upload-card em {
    max-width: 260px;
  }

  .order-divider {
    display: none;
  }

  .dialog-footer {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 10px 16px 14px;
    flex: 0 0 auto;
  }

  .privacy-note {
    max-width: none;
  }

  .dialog-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .dialog-actions button {
    width: 100%;
    height: 40px;
  }
}

@media (max-width: 420px) {
  .action-row {
    grid-template-columns: 1fr;
  }

  .quantity-control {
    width: 100%;
  }

  .dialog-close {
    top: 12px;
    right: 10px;
  }

  .dialog-header {
    padding-right: 48px;
  }
}

</style>
